import type { ChatAppResponse } from "@/api/models"

import { api } from "@/lib/api-client"

export type WorkflowRunMetadata = NonNullable<ChatAppResponse["workflow_run"]>

export async function resumeWorkflowRun(
  workflowRun: WorkflowRunMetadata,
  decision: Record<string, unknown>
): Promise<WorkflowRunMetadata> {
  const run = (await api.post(
    `/explorer/workflow/${workflowRun.workflow_id}/runs/${workflowRun.id}/resume`,
    decision
  )) as unknown as WorkflowRunMetadata
  return {
    id: run.id,
    workflow_id: run.workflow_id,
    workflow_title: run.workflow_title ?? workflowRun.workflow_title,
    status: run.status,
    trigger: run.trigger,
    output: run.output,
    error: run.error,
    resumable: run.resumable,
    pending_interrupt: run.pending_interrupt,
  }
}
